import React from "react";
import { Link } from "react-router-dom";
import { FaTwitter, FaInstagram, FaDiscord } from "react-icons/fa";
import { FiMail, FiMapPin, FiHeart } from "react-icons/fi";

function Footer() {
    const currentYear = new Date().getFullYear();

    return (
        <footer className="mt-auto bg-gradient-to-t from-yellow-700 to-yellow-600 text-blue-100 border-t border-blue-900/30">
            {/* Main Footer Content */}
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12">
                    {/* Company Info */}
                    <div className="lg:col-span-1">
                        <div className="flex items-center gap-3 mb-4">
                            <img src="/semperor.svg" className="w-10 h-10 object-contain" alt="Semperor Logo" />
                            <span className="font-bold text-xl text-black">Semperor Games</span>
                        </div>
                        <p className="text-black text-sm mb-4 leading-relaxed">
                            Creating mobile gaming experiences that inspire, connect, and open new worlds to players worldwide.
                        </p>
                        <div className="flex items-center gap-2 text-sm text-black">
                            <span>Built with</span>
                            <FiHeart className="text-red-900 animate-pulse" />
                            <span>by passionate developers</span>
                        </div>
                    </div>

                    {/* Quick Links */}
                    <div>
                        <h3 className="font-semibold text-black mb-4 text-lg">Quick Links</h3>
                        <ul className="space-y-3">
                            <li>
                                <Link to="/" className="text-black hover:text-black transition text-sm">
                                    Home
                                </Link>
                            </li>
                            <li>
                                <Link to="/about" className="text-black hover:text-black transition text-sm">
                                    About Us
                                </Link>
                            </li>
                            <li>
                                <Link to="/contact" className="text-black hover:text-black transition text-sm">
                                    Contact
                                </Link>
                            </li>
                        </ul>
                    </div>

                    {/* Legal & Policies */}
                    <div>
                        <h3 className="font-semibold text-black mb-4 text-lg">Legal</h3>
                        <ul className="space-y-3">
                            <li>
                                <Link to="/terms" className="text-black hover:text-black transition text-sm">
                                    Terms of Service
                                </Link>
                            </li>
                            <li>
                                <Link to="/privacy" className="text-black hover:text-black transition text-sm">
                                    Privacy Policy
                                </Link>
                            </li>
                            <li>
                                <Link to="/unsubscribe" className="text-black hover:text-black transition text-sm">
                                    Unsubscribe
                                </Link>
                            </li>
                        </ul>
                    </div>

                    {/* Contact Info */}
                    <div>
                        <h3 className="font-semibold text-black mb-4 text-lg">Get in Touch</h3>
                        <div className="space-y-4">
                            <div className="flex items-start gap-3">
                                <FiMail className="text-black mt-1 flex-shrink-0" />
                                <div>
                                    <a
                                        href="mailto:contact@semperorgames.com"
                                        className="text-black hover:text-black transition text-sm block"
                                    >
                                        contact@semperorgames.com
                                    </a>
                                    <p className="text-xs text-black mt-1">We'll respond within 24-48 hours</p>
                                </div>
                            </div>
                            <div className="flex items-start gap-3">
                                <FiMapPin className="text-black mt-1 flex-shrink-0" />
                                <div>
                                    <p className="text-black text-sm">
                                        Jønningsheiveien 43<br />
                                        4316 Sandnes, Norway
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Bottom Bar */}
            <div className="border-t border-blue-900/30 bg-[#021428]/50">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
                    <div className="flex flex-col md:flex-row items-center justify-center gap-4">
                        {/* Copyright */}
                        <div className="text-sm text-black text-center md:text-left">
                            <p>
                                © {currentYear} Semperor Games. All rights reserved.
                            </p>
                        </div>

                        {/* Social Media */}
                        {/* <div className="flex items-center gap-4">
                            <span className="text-sm text-blue-300 hidden sm:block">Follow us:</span>
                            <div className="flex gap-4">
                                <a
                                    href="#"
                                    className="text-blue-300 hover:text-black hover:scale-110 transition transform"
                                    aria-label="Twitter"
                                >
                                    <FaTwitter className="text-xl" />
                                </a>
                                <a
                                    href="#"
                                    className="text-blue-300 hover:text-black hover:scale-110 transition transform"
                                    aria-label="Instagram"
                                >
                                    <FaInstagram className="text-xl" />
                                </a>
                                <a
                                    href="#"
                                    className="text-blue-300 hover:text-black hover:scale-110 transition transform"
                                    aria-label="Discord"
                                >
                                    <FaDiscord className="text-xl" />
                                </a>
                            </div>
                        </div> */}
                    </div>
                </div>
            </div>
        </footer>
    );
}

export default Footer;